// extracted by mini-css-extract-plugin
module.exports = {"halo":"SafeLogoHalo_halo__UTYtR","logoDarkFill":"SafeLogoHalo_logoDarkFill__Erc3J"};